
import { RotatingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { RootState } from '../../service/store';
import { GLOBAL_CONSTANTS } from "../../constants";
const LoaderComponent = () => {

    const LoaderActive = useSelector((state: RootState) => state.static.loader);
    return (
        <>
            {LoaderActive &&
                <div className="spinner_container">
                    <RotatingLines
                        visible={true}
                        width="96"
                        strokeColor={GLOBAL_CONSTANTS.COLOR_CODE.PRIMARY}
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                    />
                </div>
            }
        </>
    )
}

export default LoaderComponent;